import React from "react";

const Services = () => {
  const services = [
    {
      name: "Web Application Development",
      desc: "Designing and building production-ready web applications with a focus on performance, maintainability, and clean user experiences.",
      icon: "fas fa-desktop",
    },
    {
      name: "Frontend Engineering",
      desc: "Building scalable, component-driven interfaces using React and modern JavaScript patterns, with careful attention to state management and usability.",
      icon: "fas fa-code",
    },
    {
      name: "Backend & API Development",
      desc: "Developing backend services and APIs using Python and Node.js, backed by relational databases and designed for reliability and scale.",
      icon: "fas fa-server",
    },
    {
      name: "Cloud & Containerised Systems",
      desc: "Working with Docker and cloud platforms to deploy, run, and maintain services in real-world production environments.",
      icon: "fas fa-cloud",
    },
    {
      name: "UI & UX Engineering",
      desc: "Applying UX principles to create interfaces that are intuitive, accessible, and practical, informed by both design and engineering experience.",
      icon: "fas fa-window-restore",
    },
    {
      name: "Interactive & Game Development",
      desc: "A background in game development that informs my approach to interaction design, performance, and building engaging user experiences.",
      icon: "fas fa-gamepad",
    },
  ];


  return (
    <section id="services" className="section bg-light">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">What I Do?</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          Technical Experience
        </h2>
        {/* Heading end*/}
        <div className="row gy-5 mt-5">
          {services.length > 0 &&
            services.map((service, index) => (
              <div className="col-sm-6 col-lg-4 wow fadeInUp" key={index}>
                <div className="featured-box text-center px-md-4">
                  <div className="featured-box-icon text-primary text-13">
                    {" "}
                    <i className={service.icon} />
                  </div>
                  <h3 className="text-6 fw-600 mb-3">{service.name}</h3>
                  <p className="text-muted mb-0">{service.desc} </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
